"use client";

import { useState } from "react";
import cls from "./BlogFaq.module.css";
import { ChevronDownIcon } from "@/utils/images/Blog";

export interface FaqItem {
    question: string;
    answer: string;
}

interface BlogFaqProps {
    items: FaqItem[];
    title?: string;
    id?: string;
}

export const BlogFaq = ({ items, title = "Frequently Asked Questions", id = "faq" }: BlogFaqProps) => {
    const [openIndex, setOpenIndex] = useState<number | null>(null);

    if (items.length === 0) return null;

    const handleToggle = (index: number) => {
        setOpenIndex(openIndex === index ? null : index);
    };

    return (
        <section className={cls.faq}>
            <h2 id={id} className={cls.title}>{title}</h2>

            <div className={cls.list}>
                {items.map((item, index) => {
                    const isOpen = openIndex === index;

                    return (
                        <div key={index} className={`${cls.item} ${isOpen ? cls.open : ""}`}>
                            <button
                                type="button"
                                className={cls.question}
                                onClick={() => handleToggle(index)}
                                aria-expanded={isOpen}
                            >
                                <span>{item.question}</span>
                                <span className={`${cls.icon} ${isOpen ? cls.iconOpen : ""}`}>
                                    <ChevronDownIcon style={{width: "24px", height: "24px"}}/>
                                </span>
                            </button>

                            <div className={`${cls.answerWrapper} ${isOpen ? cls.answerOpen : ""}`}>
                                <p className={cls.answer}>{item.answer}</p>
                            </div>
                        </div>
                    );
                })}
            </div>
        </section>
    );
};
